import { render, staticRenderFns } from "./AdminInvoiceList.vue?vue&type=template&id=3473edc5"
import script from "./AdminInvoiceList.vue?vue&type=script&lang=js"
export * from "./AdminInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports